<script>
  import { navigationStore } from "../stores/navigationStore";
  export let open = false;

  import { slide, fly } from "svelte/transition";
</script>

{#if open}
  <aside
    in:fly={{ duration: 700, x: 1000, y: 10, opacity: 0.8 }}
    out:slide
    class="absolute w-full h-full bg-gray-200 border-r-2 shadow-lg"
    class:open
  >
    <nav>
      <ul>
        <li>
          <a
            class:active={$navigationStore.home}
            on:click={() => {
              navigationStore.scrollToTop();
              open = false;
            }}
          >
            Home
          </a>
        </li>
        <li>
          <a
            class:active={$navigationStore.about}
            on:click={() => {
              navigationStore.scrollTo("#about");
              open = false;
            }}
          >
            About
          </a>
        </li>
        <li>
          <a
            class:active={$navigationStore.benefits}
            on:click={() => {
              navigationStore.scrollTo("#benefits");
              open = false;
            }}>Benefits</a
          >
        </li>
        <li>
          <a
            class:active={$navigationStore.features}
            on:click={() => {
              navigationStore.scrollTo("#features");
              open = false;
            }}>Features</a
          >
        </li>
        <li>
          <a
            class:active={$navigationStore.contacts}
            on:click={() => {
              navigationStore.scrollTo("#contacts");
              open = false;
            }}>Contacts</a
          >
        </li>
      </ul>
    </nav>
  </aside>
{/if}

<style>
  aside {
    height: 260px;
    position: fixed;
    top: 56px;
    width: 100vw;

    background: #f9f9f9;

    box-shadow: 0px 10px 36px rgba(86, 102, 237, 0.25);
  }

  nav {
    width: 100%;
    height: 100%;
  }

  ul {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    justify-content: space-evenly;
    list-style: none;
  }

  li:hover {
    transform: scale(0.97);
  }

  li:hover a {
    text-decoration: underline;
  }

  li:last-of-type {
    margin-bottom: 32px;
  }

  .active {
    color: var(--primary-color);
  }

  a {
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    font-size: 16px;
  }
</style>
